import React, { useState } from "react";
import { useRecommendationStore } from "../../stores/recommendationStore";
import RecommendationForm from "./RecommendationForm";
import RecommendationPriceToggle from "./RecommendationPriceToggle";
import RecommendationTablesPickPanel from "./RecommendationTablesPickPanel";
import RecommendationPricetagButton from "./RecommendationPricetagButton";
import {
  SearchBar,
  RefreshButton,
  FilterModal,
  FilterButton,
  PermissionWrapper,
  AnimatedCheckboxButton,
} from "components";
import { zeroStocksIcon, customPriceIcon, tagIcon, truckIcon } from "assets";
import { ROZETKA_WAREHOUSE_ID } from "../../utils/warehouses";

// Компонент заголовка сторінки рекомендацій
const RecommendationHeader = () => {
  // Отримуємо дані та дії зі стору рекомендацій
  const filters = useRecommendationStore((state) => state.filters);
  const isLoading = useRecommendationStore((state) => state.isLoading);
  const categoryOptions = useRecommendationStore((state) => state.categoryOptions);
  const fetchRecommendations = useRecommendationStore(
    (state) => state.fetchRecommendations,
  );
  const setSearch = useRecommendationStore((state) => state.setSearch);
  const applyFilters = useRecommendationStore((state) => state.applyFilters);
  const setIsFull = useRecommendationStore((state) => state.setIsFull);
  const setHasCustomPrice = useRecommendationStore((state) => state.setHasCustomPrice);
  const setInTransit = useRecommendationStore((state) => state.setInTransit);
  const customTags = useRecommendationStore((state) => state.customTags);
  const toggleTagFilter = useRecommendationStore((state) => state.toggleTagFilter);
  const stocks = useRecommendationStore((state) => state.stocks);

  const [isFilterOpen, setFilterOpen] = useState(false);

  return (
    <div className="recommendation-title">
      <div className="recommendation-title-line">
        <div className="title-container">
          <RefreshButton onRefresh={fetchRecommendations} disabled={isLoading} />
          <h3>Рекомендовані ціни товарів</h3>
          <div className="search-container">
            <SearchBar value={filters.search} onSearch={(value) => setSearch(value)} />
            <FilterButton
              onClick={() => setFilterOpen(true)}
              isActive={filters.category_id !== null}
            />
            <FilterModal
              isOpen={isFilterOpen}
              onClose={() => setFilterOpen(false)}
              onApply={applyFilters}
              filters={[
                {
                  id: "category_id",
                  label: "Категорія",
                  options: categoryOptions,
                  value: filters.category_id,
                  placeholder: "Усі категорії",
                  type: "autocomplete",
                  valueKey: "id",
                  labelKey: "name",
                },
              ]}
            />
          </div>
        </div>
        {/* У розділі Rozetka є лише одна ціна, перемикач цін не потрібен */}
        {filters.warehouse_id !== ROZETKA_WAREHOUSE_ID && <RecommendationPriceToggle />}
      </div>
      <div className="recommendation-title-line">
        <PermissionWrapper requiredPermission="recommendations:edit-prices">
          <RecommendationForm />
        </PermissionWrapper>

        <RecommendationPricetagButton isEmpty={!stocks.length} />
      </div>
      <div className="recommendation-title-line">
        <RecommendationTablesPickPanel />
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <AnimatedCheckboxButton
            id="recommendation-is-full-toggle"
            label="Нульові залишки"
            icon={zeroStocksIcon}
            checked={filters.is_full}
            onChange={(e) => setIsFull(e.target.checked)}
          />
          {/* Лише товари, на які є партія в журналі очікуваного приходу */}
          <AnimatedCheckboxButton
            id="recommendation-in-transit-toggle"
            label="Очікуваний прихід"
            icon={truckIcon}
            title="Показати лише товари, які їдуть на склад"
            checked={filters.in_transit}
            onChange={(e) => setInTransit(e.target.checked)}
          />
          {/* Фільтр кастомних значень: Лід Магніт для складу 0, ручні ціни та залишки для Rozetka */}
          {(filters.warehouse_id === 0 || filters.warehouse_id === ROZETKA_WAREHOUSE_ID) && (
            <AnimatedCheckboxButton
              id="recommendation-has-custom-price-toggle"
              label={filters.warehouse_id === 0 ? "Лід Магніт" : "Ручні значення"}
              icon={customPriceIcon}
              checked={filters.has_custom_price}
              onChange={(e) => setHasCustomPrice(e.target.checked)}
            />
          )}
          {/* Фільтр за кожною кастомною міткою */}
          {customTags.map((tag) => (
            <AnimatedCheckboxButton
              key={tag.id}
              id={`recommendation-tag-${tag.id}-toggle`}
              label={tag.name}
              icon={tagIcon}
              title={tag.description || tag.name}
              checked={filters.tag_ids.includes(tag.id)}
              onChange={() => toggleTagFilter(tag.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecommendationHeader;
